var a = "_wrapper_15a51_1",
    n = "_copyTextContainer_15a51_16",
    e = "_wrapperLoading_15a51_29",
    r = "_wrapperResizeable_15a51_33",
    o = "_wrapperResizeableVariable_15a51_36",
    t = "_wrapperFocused_15a51_41",
    i = "_wrapperWithError_15a51_45",
    _ = "_inputWrapper_15a51_49",
    p = "_variable_15a51_56",
    s = "_autoSizeInput_15a51_59",
    l = "_bothControls_15a51_79",
    c = "_input_15a51_49",
    b = "_withControl_15a51_113",
    C = "_labelContainer_15a51_129",
    w = "_inputContainer_15a51_136",
    u = "_symbolsCounter_15a51_141",
    d = "_skeletonContainer_15a51_146",
    h = "_spinnerIcon_15a51_157",
    z = "_hiddenSpan_15a51_177",
    y = "_variableHiddenSpan_15a51_184",
    v = "_withCopy_15a51_190",
    R = "_variableResizeContainer_15a51_194",
    S = "_emojiContainer_15a51_198",
    W = "_isVariable_15a51_203",
    m = "_containerWithError_15a51_208",
    E = {
  wrapper: a,
  copyTextContainer: n,
  wrapperLoading: e,
  wrapperResizeable: r,
  wrapperResizeableVariable: o,
  wrapperFocused: t,
  wrapperWithError: i,
  inputWrapper: _,
  variable: p,
  autoSizeInput: s,
  bothControls: l,
  input: c,
  withControl: b,
  labelContainer: C,
  inputContainer: w,
  symbolsCounter: u,
  skeletonContainer: d,
  spinnerIcon: h,
  "loading-animation": "_loading-animation_15a51_1",
  hiddenSpan: z,
  variableHiddenSpan: y,
  withCopy: v,
  variableResizeContainer: R,
  emojiContainer: S,
  isVariable: W,
  containerWithError: m
};
export { s as autoSizeInput, l as bothControls, m as containerWithError, n as copyTextContainer, E as default, S as emojiContainer, z as hiddenSpan, c as input, w as inputContainer, _ as inputWrapper, W as isVariable, C as labelContainer, d as skeletonContainer, h as spinnerIcon, u as symbolsCounter, p as variable, y as variableHiddenSpan, R as variableResizeContainer, b as withControl, v as withCopy, a as wrapper, t as wrapperFocused, e as wrapperLoading, r as wrapperResizeable, o as wrapperResizeableVariable, i as wrapperWithError };